import React, { useEffect, useState } from "react";
import { Card, Button, Typography, message } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { routePaths } from "../../routing/routePaths";
import { useDispatch, useSelector } from "react-redux";
import i18n from "../../localization/i18n";
import { verifyUser } from "../../controller/services/auth";
import { setLoading } from "../../redux/slices/common_slice";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

const EmailVerified = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const [data, setData] = useState(null);
  // Use URLSearchParams to parse the query string
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  console.log(id, "params");

  useEffect(() => {
    if (id) {
      handleUserVerification();
    }
  }, [id]);
  const handleUserVerification = async () => {
    dispatch(setLoading(true));
    verifyUser(id)
      .then((resp) => {
        setData(resp);
        // message.success(resp.message[i18n.language]);
      })
      .catch((err) => {
        message.error(err.message[i18n.language] || "Something went wrong");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  return (
    <div style={styles.container}>
      {data?.status ? (
        <Card style={styles.card} bordered={false} bodyStyle={styles.cardBody}>
          <div style={styles.iconContainer}>
            <CheckCircleOutlined style={styles.icon} />
          </div>
          <Title level={2} style={styles.title}>
            {t("emailVerify.status")}
          </Title>
          <Text style={styles.description}>{t("emailVerify.message")}</Text>
          <Button
            type="primary"
            style={styles.button}
            onClick={() => navigate(routePaths.login)}
          >
            {t("emailVerify.button")}
          </Button>
        </Card>
      ) : (
        ""
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f4f5f7", // Light background color
  },
  card: {
    width: 400,
    borderRadius: 12,
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    backgroundColor: "#ffffff",
  },
  cardBody: {
    padding: "24px",
  },
  iconContainer: {
    textAlign: "center",
    marginBottom: "16px",
  },
  icon: {
    fontSize: "64px",
    color: "#156fff", // Primary color
  },
  title: {
    textAlign: "center",
    color: "#222222", // Dark color for the title
  },
  description: {
    display: "block",
    textAlign: "center",
    color: "#a4a5b4", // Secondary color for the description
    marginBottom: "24px",
  },
  button: {
    display: "block",
    width: "100%",
    backgroundColor: "#156fff", // Primary color for the button
    borderColor: "#156fff",
    color: "#ffffff",
  },
};

export default EmailVerified;
